import { useAppDispatch, useAppSelector } from "app/hooks";
import Panel from "shared/components/Panel";
import { setOpenPanel } from "features/settings/details-slice";
import { useCallback } from "react";

interface PanelReportViewProps {}
const PanelReportView: React.FC<PanelReportViewProps> = () => {
  const showPanel = useAppSelector(
    (state) => state.settings.openPanel === "reportView"
  );
  const guid = useAppSelector((state) => state.panorama.guid);
  const fieldReportUrl = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.field_report_url
  );

  const dispatch = useAppDispatch();
  const closePanel = useCallback(
    () => dispatch(setOpenPanel(null)),
    [dispatch]
  );
  return (
    <Panel
      showPanel={showPanel}
      direction="left"
      retainBottomMenu
      headerBorder="BorderBottom"
      closePanel={closePanel}
      includeBaseHeader
      panelSize="large"
      underlayClass="NoUnderlay"
      headerElement={<h2>Report</h2>}
    >
      {fieldReportUrl && guid ? (
        <iframe
          src={fieldReportUrl.replace("[GUID]", guid)}
          title="Field Report"
          className="FieldReportIframe"
        />
      ) : (
        <>An unknown error occurred! Please try again later.</>
      )}
    </Panel>
  );
};

export default PanelReportView;
